var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import { Select, MenuItem, InputLabel } from '@material-ui/core';
import TextField from '../TextField/TextField';
import { usePhoneView } from '../../hooks/usePhoneView';
export default (function (props) {
    var defVal = props.default || { value: props.value || '', label: '' };
    var phoneView = usePhoneView();
    if (!props.value) {
        for (var i = 0; i < props.options.length; i++) {
            if (props.options[i].value !== defVal.value)
                continue;
            defVal.label = props.options[i].label;
            break;
        }
    }
    var _a = useState(props.error ? 'rgb(212, 42, 42)' : undefined), color = _a[0], setColor = _a[1];
    useEffect(function () {
        setColor(props.error ? 'rgb(212, 42, 42)' : color);
    }, [props.error, color]);
    var _b = useState({ select1: defVal.value }), values = _b[0], setValues = _b[1];
    var handleBlur = function () {
        setColor(undefined);
    };
    useEffect(function () {
        setValues({ select1: defVal.value });
    }, [defVal.value]);
    var handleChange = function (event) {
        setColor('rgb(102,175,78)');
        setValues(function (oldValues) {
            var _a;
            return (__assign(__assign({}, oldValues), (_a = {}, _a[event.target.name] = event.target.value, _a)));
        });
        // eslint-disable-next-line no-param-reassign
        event.target.id = props.id;
        if (props.onChange)
            props.onChange(event);
    };
    var counter = 0;
    if (props.readOnly) {
        var val = props.options.find(function (item) { return item.value === props.value; }) || {};
        return (React.createElement(TextField, { id: props.id, label: props.title, error: props.error, value: val.label, required: true, variant: "standard", style: { display: 'flex', flexWrap: 'wrap' }, readOnly: props.readOnly }));
    }
    var showSmallFont = props.fromList && phoneView;
    return (React.createElement("div", null,
        props.title ? (React.createElement(InputLabel, { style: {
                fontSize: '0.75rem',
                lineHeight: '1rem',
                color: color,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
            } },
            props.title,
            props.required ? ' *' : '')) : null,
        React.createElement(Select, { id: props.id, value: values.select1, onChange: handleChange, onBlur: handleBlur, style: { width: '100%' }, className: "".concat(props.className || '', " ").concat(props.readOnly ? 'customSelectReadOnly' : ''), error: props.error, variant: props.variant, readOnly: props.readOnly, disabled: props.disabled, disableUnderline: props.disableUnderline, inputProps: { name: 'select1' }, SelectDisplayProps: __assign({}, (showSmallFont && { style: { fontSize: 'small', whiteSpace: 'break-spaces' } })) }, props.options.map(function (f) { return (React.createElement(MenuItem, { key: "menu-item-".concat((counter++).toString()), value: f.value, style: __assign({ color: f.value === props.unselectedValue ? '#999' : undefined }, (showSmallFont && { fontSize: 'small', minHeight: 0 })) }, f.label)); }))));
});
//# sourceMappingURL=ListingFilterSelect.js.map